import { useState, useEffect } from 'react'

interface InfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export function InfoModal({ isOpen, onClose }: InfoModalProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted || !isOpen) return null

  return (
    <>
      <div
        className="fixed inset-0 z-50 bg-black/50 animate-in fade-in-0"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none p-4">
        <div className="bg-background rounded-[var(--card-radius)] shadow-lg max-w-sm w-full max-h-[85vh] animate-in zoom-in-95 pointer-events-auto overflow-y-auto">
          <div className="p-6 space-y-4 text-left">
            <h2 className="text-xl font-semibold text-foreground">Guest spots info</h2>

            <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
              <div>
                <h3 className="text-base font-semibold text-foreground">How is this made?</h3>
                <p className="mt-1.5">
                  We use publicly available data, mostly from Instagram, to provide a free
                  overview for tattoo fans to see which artists are coming to their city.
                </p>
              </div>

              <div>
                <h3 className="text-base font-semibold text-foreground">For artists</h3>
                <p className="mt-1.5">
                  If you want an enriched entry with your portfolio images, create a profile on
                  our platform. DM us on Instagram{' '}
                  <a
                    href="https://instagram.com/getmoretats"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-foreground hover:text-primary transition-colors"
                  >
                    @getmoretats
                  </a>{' '}
                  so we can verify it&apos;s you — we&apos;ll hop on a short call since we talk to
                  every artist with a profile.
                </p>
                <p className="mt-2">You can also DM us if you want to:</p>
                <ul className="mt-1 list-disc space-y-1 pl-5">
                  <li>Update info on an existing guest spot</li>
                  <li>Add a new guest spot without a full profile</li>
                  <li>Request removal from this page</li>
                </ul>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-3 rounded-lg transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
